import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import App from "~/App";
import AuthProvider from "~/auth/AuthProvider";
import { persistor, store } from "~/store";
import "~/index.css";

const container = document.getElementById("root");
if (!container) {
	throw new Error("Root element #root not found");
}

createRoot(container).render(
	<StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					{/* AuthProvider sits above the router's guarded consumers (RequireAuth/RequireSite)
					    and inside BrowserRouter so the /oauth-redirect callback can use router hooks. */}
					<AuthProvider>
						<App />
					</AuthProvider>
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</StrictMode>
);
